export const TICK = 3000
export const RAIN_CHANCE = 0.2
export const WEATHER_TICKS = 3
export const DAY_TICKS = 14
export const NIGHT_TICKS = 6
export const MOOD_TICKS = 3
